const companyConfigs = JSON.parse(process.env.REACT_APP_COMPANY);

if (companyConfigs) {
    Object.freeze(companyConfigs);
}

export default companyConfigs;
